export class TipoVeiculoData {
    static data: any = null
}
